import Enterprise32 from '@carbon/icons-react/es/enterprise/32';
import { useInterval } from 'ahooks';
import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Company } from 'api/models';
import { Loading } from 'components/atoms/loading';
import { Logo, LogosContainer } from './logo';
import { CompanyOption } from './types';

const LoaderContainer = styled.div`
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: var(--white-100);
  position: fixed;
  z-index: 999;
  flex-direction: column;
`;

const StyledLogoContainer = styled(LogosContainer)`
  width: 272px;
`;

const MessageContainer = styled.div`
  padding: var(--spacing-08);
`;

interface ProjectCreationLoaderProps {
  customer: CompanyOption;
  vendor: Company;
}

export const ProjectCreationLoader: FC<ProjectCreationLoaderProps> = ({
  customer,
  vendor,
}) => {
  const messages = [
    <FormattedMessage id="projects.create.loading.setting_up" />,
    <FormattedMessage id="projects.create.loading.creating" />,
    <FormattedMessage id="projects.create.loading.project_details" />,
    <FormattedMessage id="projects.create.loading.sealing" />,
    <FormattedMessage id="projects.create.loading.fuel_level" />,
    <FormattedMessage id="projects.create.loading.team" />,
    <FormattedMessage id="projects.create.loading.seat_belts" />,
    <FormattedMessage id="projects.create.loading.engine_on" />,
    <FormattedMessage id="projects.create.loading.launching" />,
  ];

  const lastIndex = messages.length - 1;
  const [index, setIndex] = useState(0);

  useInterval(() => {
    if (index < lastIndex) {
      setIndex(index + 1);
    }
  }, 700);

  return (
    <LoaderContainer>
      <StyledLogoContainer>
        <Logo
          size={88}
          src={vendor.companyLogoUrl}
          name={vendor.companyName}
          icon={<Enterprise32 />}
        />
        <Loading />
        <Logo
          size={88}
          src={customer.imageUrl}
          name={customer.label}
          icon={<Enterprise32 />}
        />
      </StyledLogoContainer>
      <MessageContainer>{messages[index]}</MessageContainer>
    </LoaderContainer>
  );
};
